export default class CookiesPopup {
    domModalWrap;
    domCookieBtn;

    constructor() {
        if (!(this.domModalWrap = document.querySelector(".cookies-popup-wrap"))) {
            return null;
        }

        if (window.localStorage.isCookiesAccepted) {
            return;
        }

        this.domCookieBtn = this.domModalWrap.querySelector(".popup-cookies-btn");

        this.Listen();
        this.Show();
    }

    Listen() {
        this.domCookieBtn.addEventListener("click", () => this.onCookiesBtnClick());
    }

    Show() {
        this.domModalWrap.classList.add("show");
    }

    onCookiesBtnClick() {
        window.localStorage.isCookiesAccepted = true;
        this.domModalWrap.classList.add("accepted");
    }
}
